import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import LoadingService from '../common/services/loadingService';
import ErrorService from '../common/services/errorService';
import UserService from '../common/services/userService';
import AccountService from '../common/services/accountService';
import CommonService from '../common/services/commonService';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import EMailInputComponent from './components/emailInput';
import SignInComponent from './components/signin';
import EmailSentComponent from './components/emailSent';
import RegistrationComponent from './components/checkRegistration';
import NotFoundComponent from './components/notFoundComponent';
import SingleSignOnComponent from './components/singleSignOn.vue';
import {
  MUTATION_QUERY_PARAMETERS,
  MUTATION_REGISTRATION_EMAIL,
  MUTATION_REGISTRATION_USERS
} from './constants';
import Multiselect from 'vue-multiselect';
import { store } from './store';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.css';

let initialQueryParametersProcessed = false;

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuelidate);
Vue.component('multiselect', Multiselect);
Vue.config.productionTip = false;

const routes = [
  {
    name: 'single-sign-on',
    path: '/single-sign-on',
    component: SingleSignOnComponent
  },
  {
    name: 'registration',
    path: '/registration',
    component: RegistrationComponent
  },
  { name: 'signin', path: '/signin', component: SignInComponent },
  { name: 'emailSent', path: '/email-sent', component: EmailSentComponent },
  { name: 'emailInput', path: '/', component: EMailInputComponent },
  { name: 'notfound', path: '*', component: NotFoundComponent }
];

const router = new VueRouter({
  routes // short for `routes: routes`
});

router.beforeEach((to, from, next) => {
  const loc = window.location;
  if (!initialQueryParametersProcessed) {
    if (loc.search && loc.search.length > 0) {
      var queryValues = loc.search.substring(1).split('&');
      let queryObj = {};
      for (let q of queryValues) {
        const valTok = q.split('=');
        if (valTok.length > 1) {
          queryObj[valTok[0].toLowerCase()] = decodeURIComponent(valTok[1]);
        }
      }

      initialQueryParametersProcessed = true;
      store.commit(MUTATION_QUERY_PARAMETERS, queryObj);
    } else {
      store.commit(MUTATION_QUERY_PARAMETERS, {});
    }
  }

  next();
});

Vue.prototype.$loadingService = new LoadingService();
Vue.prototype.$errorService = new ErrorService();
Vue.prototype.$userService = new UserService();
Vue.prototype.$accountService = new AccountService();
Vue.prototype.$commonService = new CommonService();

new Vue({
  router,
  render: function (h) {
    return h(App);
  },
  store
}).$mount('#app');
